import { ON_LOGOUT } from 'app/actions/authActions';
import { createReducer, getError } from 'utils/appHelpers';
import { API, graphqlOperation } from 'aws-amplify';
import { getPoll, listPolls } from 'graphql/polls/queries';
import { createPollMutation, createPollVoteMutation, updatePollMutation } from 'graphql/polls/mutations';
import store from 'redux/store';

const ON_POLSS_GET = '@@home/ON_POLSS_GET';
const ON_CREATE_POLL = '@@home/ON_CREATE_POLL';
const ON_POLL_UPDATE_STATE = '@@home/ON_POLL_UPDATE_STATE';
const ON_POLL_CREATE_VOTE = '@@home/ON_POLL_CREATE_VOTE';

const constructPolls = polls => {
  const account = store.getState().account;
  if (Array.isArray(polls)) {
    return polls.map(item => {
      item.isOwner = item.owner === account.id;
      return item;
    });
  } else {
    polls.isOwner = polls.owner === account.id;
    return polls;
  }
};

const pollsHandlers = {
  [ON_POLSS_GET]: (state, action) => action.payload,
  [ON_CREATE_POLL]: (state, action) => {
    const tempState = [...state];
    tempState.unshift(action.payload);
    return tempState;
  },
  [ON_POLL_UPDATE_STATE]: (state, action) => {
    const { id, isActive } = action.payload;
    const tempState = [...state];
    const index = tempState.findIndex(i => i.id === id);
    tempState[index].isActive = isActive;
    return tempState;
  },
  [ON_POLL_CREATE_VOTE]: (state, action) => {
    const { id, votes } = action.payload;
    const tempState = [...state];
    const index = tempState.findIndex(i => i.id === id);
    tempState[index].votes = [...votes];
    return tempState;
  },
  [ON_LOGOUT]: () => {
    return [];
  },
};

const onSetPolls = payload => ({ type: ON_POLSS_GET, payload });
const onCreatePoll = payload => ({ type: ON_CREATE_POLL, payload });
const onUpdatePollState = payload => ({ type: ON_POLL_UPDATE_STATE, payload });
const onCreatePollVote = payload => ({ type: ON_POLL_CREATE_VOTE, payload });

export const getPolls = async () => {
  try {
    const body = { limit: 1000 };
    const { data } = await API.graphql(graphqlOperation(listPolls, body));
    const result = constructPolls(data.listPolls.items);
    store.dispatch(onSetPolls(result));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const getPollData = async id => {
  try {
    const body = { id };
    const { data } = await API.graphql(graphqlOperation(getPoll, body));
    const poll = data.getPoll;
    const polls = store.getState().polls;
    const currentIndex = polls.find(i => i.id === poll.id);
    if (poll[currentIndex]) {
      poll[currentIndex] = poll;
    } else {
      polls.push(poll);
    }
    store.dispatch(onSetPolls(constructPolls(polls)));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const createPoll = async form => {
  try {
    const { data } = await API.graphql(graphqlOperation(createPollMutation, { input: { ...form } }));
    const poll = constructPolls(data.createPoll);
    store.dispatch(onCreatePoll(poll));
    return poll;
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const togglePollState = async (id, isActive) => {
  try {
    const input = { id, isActive };
    await API.graphql(graphqlOperation(updatePollMutation, { input }));
    store.dispatch(onUpdatePollState(input));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const createPollVote = async (pollId, vote) => {
  try {
    const input = { pollId, vote };
    const pollVote = await API.graphql(graphqlOperation(createPollVoteMutation, { input }));
    const votes = pollVote.data.createPollVote?.poll?.votes;
    store.dispatch(onCreatePollVote({ id: pollId, votes }));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const getPollVotesResult = votes => {
  const result = { first: 0, second: 0 };
  if (votes?.length) {
    result.first = (([...votes].filter(i => i.vote === 'FIRST').length / votes.length) * 100).toFixed();
    result.second = (([...votes].filter(i => i.vote === 'SECOND').length / votes.length) * 100).toFixed();
  }
  return result;
};

export const getUserVote = votes => {
  if (!votes?.length) return false;
  const account = store.getState().account;
  return votes.find(i => i.owner === account.id)?.vote;
};

export const pollsReducer = createReducer(null, pollsHandlers);
